module.exports = __webpack_public_path__ + "static/img/db0a248.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/xczx/img/swipe_04.png
// module id = 703
// module chunks = 2